/* Builds the Watchlist Report URL for a dashboard card's "View All →" link (spec §4). */
export const buildReportLink = (params: Record<string, string | number | null | undefined>): string => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v != null && v !== '') qs.set(k, String(v));
    });
    return `/support/watchlist-report?${qs.toString()}`;
};

/* Builds the Custom Watchlist Report URL for a custom watchlist card's "View All →" link. */
export const buildCustomReportLink = (params: Record<string, string | number | null | undefined>): string => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v != null && v !== '') qs.set(k, String(v));
    });
    return `/support/custom-watchlist-report?${qs.toString()}`;
};

// Layer-1 cards key by the full pool column (e.g. cxo_leadership_pool); the report/snapshot uses
// the short code (cxo_leadership). Strip the trailing _pool.
export const poolToWatchlistCode = (pool: string): string => pool.replace(/_pool$/, '');
